import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CoreResponse, FavItems, SessionInfo, SystemMenus } from '../../model/shared/model';
import { tap, map, delay, catchError } from 'rxjs/operators';
import { LocalStorageService } from './local-storage.service';
import { Provider } from '../../model/providers/ServiceProviders';
import { IdleTimeoutService } from './idle-timeout.service';
import { EnvService } from '../../shared/environment-service/env.service';
@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  isAuthorized: boolean;
  constructor(private http: HttpClient, public localStorageService: LocalStorageService,
    private idleTimeoutService: IdleTimeoutService, public env: EnvService) { }


  GetUserInfo(username): Observable<any> {

    const headerDict = {
      'use_main_db': 'true',
      'token': this.getToken()
    }
    const url =this.env.Environment.carenetApiUrl + 'api/Security/GetUserInfo?username=' + username;
    return this.http.get<CoreResponse<any>>(url, { responseType: 'json', headers: new HttpHeaders(headerDict) }).pipe(map(data =>

      data.content));
  }

  UpdatePasswod(oldPassword, newPassword, confirmPassword, userName): Observable<any> {
    let data = {
      'oldPassword': oldPassword,
      'newPassword': newPassword,
      'confirmPassword': confirmPassword,
      'username': userName
    };

    //For HTTPPost
    const url =this.env.Environment.carenetApiUrl + 'api/Security/ChangePassword';
    const options = { headers: { 'Content-Type': 'application/json', 'use_main_db': 'true', } };
    return this.http.post(url, data, options);
  }

  getsystemURL(applicationId, companyId): Observable<SystemMenus[]> {

    let mainSystemURL: Observable<SystemMenus>;
    const headerDict = {
      'use_main_db': 'true',
      'token': this.getToken()
    }
    const url =this.env.Environment.carenetApiUrl + 'api/Security/LoadApplicationMenu?companyId=' + companyId + '&applicationId=' + applicationId;
    return this.http.get<CoreResponse<SystemMenus[]>>(url, { responseType: 'json', headers: new HttpHeaders(headerDict) }).pipe(map(data =>

      data.content));
  }

  generateApplicationMenus(username, applicationId, companyId, languageId,providerId,systemCode): Observable<SystemMenus[]> {

    const headerDict = {
      'use_main_db': 'true',
      'token': this.getToken()
    }

 
    const url =this.env.Environment.carenetApiUrl + 'api/Security/LoadAuthorizedMenuReferralPortal?companyId=' + companyId + '&applicationId=' + applicationId + '&username=' + username + '&language=' + languageId+'&providerId='+providerId+'&systemCode='+systemCode ;
    return this.http.get<CoreResponse<SystemMenus[]>>(url, { responseType: 'json', headers: new HttpHeaders(headerDict) }).pipe(map(data =>

      data.content));
  }



  GetFavoritePagesByUser(username, companyId, languageId): Observable<FavItems[]> {

    const headerDict = {
      'use_main_db': 'true',
      'token': this.getToken()
    }
    const url =this.env.Environment.carenetApiUrl + 'api/Security/GetFavoritePages?username=' + username + '&companyId=' + companyId + '&languageId=' + languageId;
    return this.http.get<CoreResponse<FavItems[]>>(url, { responseType: 'json', headers: new HttpHeaders(headerDict) }).pipe(map(data =>

      data.content));
  }

  LogOutUser(sessionId): Observable<SessionInfo[]> {
    const headerDict = {
      'use_main_db': 'true',
      'token': this.getToken()
    }

    let user = this.getLoggedInUser();


    const url =this.env.Environment.carenetApiUrl + 'api/Security/Logout?SessionId=' + sessionId + '&username=' + user.Username;
    return this.http.get<CoreResponse<SessionInfo[]>>(url, { responseType: 'json', headers: new HttpHeaders(headerDict) }).pipe(map(data =>

      data.content));
  }

  logOut() {
    this.LogOutUser(this.getSessionId()).toPromise().then(data => { });
    this.idleTimeoutService.stopTimer();
  }


  getToken() {
    if (this.localStorageService.GetItem('token')) {
      return this.localStorageService.GetItem('token');
    }
    else {
      if (this.localStorageService.GetItem('fakeToken')) {
        return this.localStorageService.GetItem('fakeToken');
      }
      else
        return '';
    }
  }

  setToken(token) {
    this.localStorageService.SetItem('token', token);
  }

  getLoginSource() {
    if (this.localStorageService.GetItem('loginSource')) {
      return this.localStorageService.GetItem('loginSource');
    }
    else {
      return '';

    }
  }


  getSessionId() {
    if (this.localStorageService.GetItem('sessionId')) {
      return this.localStorageService.GetItem('sessionId');
    }
    else {
      return null;
    }
  }


  setSessionId(sessionId) {
    //window.localStorage['sessionId'] = sessionId;
    this.localStorageService.SetItem('sessionId', sessionId);
  }

  setLoggedInProvider(provider) {
    this.localStorageService.SetItem('loggedInProvider', JSON.stringify(provider));
    //this.localStorageService.SetItem('loggedInProvider',JSON.stringify(provider));
  }

  getLoggedInProvider(): Provider {
    if (this.localStorageService.GetItem('loggedInProvider') && this.localStorageService.GetItem('loggedInProvider') != "null" && this.localStorageService.GetItem('loggedInProvider') != "undefined") {
      //return this.localStorageService.GetItem('loggedInProvider');
      return (this.localStorageService.GetItem('loggedInProvider') ? (JSON.parse(this.localStorageService.GetItem('loggedInProvider'))) : null);
    }
    else {
      //this.logout();
      return null;
    }
  }

  setLoggedInUser(user) {
    this.localStorageService.SetItem('loggedInUser', JSON.stringify(user));
  }

  getLoggedInUser() {
    if (this.localStorageService.GetItem('loggedInUser')) {
      return (this.localStorageService.GetItem('loggedInUser') ? (JSON.parse(this.localStorageService.GetItem('loggedInUser'))) : null);
    }
    else {
      //this.logout();
      return null;
    }
  }


  setloggedInSettings(settings) {
    this.localStorageService.SetItem('loggedInSettings', JSON.stringify(settings));
  }

  getloggedInSettings() {
    if (this.localStorageService.GetItem('loggedInSettings')) {
      return (this.localStorageService.GetItem('loggedInSettings') ? (JSON.parse(this.localStorageService.GetItem('loggedInSettings'))) : null);
    }
    else {
      //this.logout();
      return null;
    }
  }

  setTokenExpiredate(tokenSpaninMinute) {

    var currentDate = new Date();
    currentDate.setMinutes(currentDate.getMinutes() + tokenSpaninMinute);

    //var expireDate = new Date(currentDate.getTime() + (tokenSpaninMinute * 60000));
    var expireDate = currentDate;
    //window.localStorage['tokenExpireDate'] = expireDate.getTime();
    this.localStorageService.SetItem('tokenExpireDate', expireDate.getTime());
  }

  getTokenExpiredate() {
    if (this.localStorageService.GetItem('tokenExpireDate')) {
      return this.localStorageService.GetItem('tokenExpireDate');
    }
    else {
      return null;

    }
  }
}
